<template>
    <div class="MAM_returnDeposit">
        <el-dialog title="押金模版配置" width="800px" :visible="returnDeposit.isShow" :close-on-click-modal="false"
            @close="handleClose">
            <!-- 活动说明 -->
            <!-- <el-tooltip class="item" effect="dark" placement="right-start"> -->
            <el-button type="text" style="color:#606266;font-weight:700">押金模版配置</el-button>
            <!-- </el-tooltip> -->
            <!-- 表单部分 -->
            <el-form label-position="top" label-width="80px" :model="depositForm">
                <el-form-item>
                    <el-table :data="setting" border max-height="456px">
                        <el-table-column header-align="center" align="center" min-width="100" prop="is_default" label="默认值">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.is_default" :true-label="1" :false-label="0"
                                    :disabled="scope.row.status == 0 || returnDeposit.status == 2"
                                    @change="handleDefault(scope.$index)"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" width="120" type="index"
                            label="模板ID"></el-table-column>
                        <el-table-column header-align="center" align="center" min-width="120" prop="target_money"
                            label="押金">
                            <template slot-scope="scope">
<!-- 
                                <el-input :disabled="scope.row.brand_reward_conf_id != '' && returnDeposit.type == 2"
                                    v-model="scope.row.target_money"></el-input> -->
                                <el-select v-model="scope.row.target_money" @change="((val)=>changeCompCb(val,scope.row))" placeholder="请选择">
                                    <el-option v-for="item in comp_cb_list" 
                                    :key="item.compCbId" :label="item.description"
                                    :value="item" 
                                    :disabled="scope.row.brand_reward_conf_id != '' && returnDeposit.type == 2"
                                    >
                                   </el-option>
                                </el-select>
                               
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" min-width="120" prop="reward_money"
                            label="返现">
                            <template slot-scope="scope">
                                <el-input :disabled="scope.row.brand_reward_conf_id != '' && returnDeposit.type == 2"
                                    v-model="scope.row.reward_money"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" min-width="150" prop="status" label="状态">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.status" active-text="展示" :active-value="1" inactive-text="隐藏"
                                    :inactive-value="0" :disabled="returnDeposit.status == 2"
                                    @change="handleSwitch(scope.row, scope.$index)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" min-width="120" label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="scope.$index != 0"
                                    :disabled="scope.row.brand_reward_conf_id != '' && returnDeposit.type == 2"
                                    @click="handleDel(scope.row, scope.$index)" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item v-if="setting.length < 30">
                    <el-button type="text" icon="el-icon-plus" @click="handleAdd"
                        :disabled="returnDeposit.status == 2">增加模板</el-button>
                </el-form-item>
                <el-form-item label="是否支持层层返现：">
                    <el-radio :disabled="returnDeposit.type == 2" v-model="depositForm.is_layer" :label="1">是</el-radio>
                    <el-radio :disabled="returnDeposit.type == 2" v-model="depositForm.is_layer" :label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="押金模式">
                    <el-radio v-model="depositForm.active_method" :label="1">普通押金(首刷金额等于押金金额)</el-radio>
                    <!-- <el-radio
                        v-model="depositForm.active_method"
                        :label="2"
                    >无感押金(首刷金额大于押金金额)</el-radio> -->
                </el-form-item>
                <el-form-item label="奖励模式">
                    <el-radio v-model="depositForm.is_reward" :label="1">未激活到期后正常奖励</el-radio>
                    <el-radio v-model="depositForm.is_reward" :label="2">未激活到期后不再奖励</el-radio>
                </el-form-item>
                <el-form-item label="活动截止时间：">
                    <el-date-picker size="medium" v-model="depositForm.cut_off_time" type="date" placeholder="活动截止时间"
                        value-format="yyyy-MM-dd" :picker-options="pickerOptions"
                        :disabled="returnDeposit.status == 2"></el-date-picker>
                </el-form-item>
                <el-form-item label="APP提示语设置">
                    <el-input v-model="depositForm.tips" size="medium" :disabled="returnDeposit.status != 0"></el-input>
                </el-form-item>
                <el-form-item style="margin-top:20px;">
                    <el-button type="primary" @click="handleSubmit" :disabled="returnDeposit.status == 2">提 交</el-button>
                    <div style="margin-top:10px">
                        <el-tag type="danger">温馨提示：模版最多配置30条，展示的最多为6条，且模版配置成功后，不能修改金额。</el-tag>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_returnDeposit",
    props: {
        returnDeposit: {
            type: Object
        },
        brandId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            pickerOptions: { //禁止选之前的时间
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            setting: [],
            depositForm: {
                is_reward: '1'
            },
            comp_cb_list: [],
        };
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        changeCompCb(val,row){
            row.target_money = val.depositAmt;
            row.comp_cb_id = val.compCbId;  
        },
        handleSubmit() { //提交
            let that = this;
            this.depositForm.setting = JSON.stringify(this.setting);
            this.depositForm.brand_id = this.brandId;
            this.$confirm('活动配置完成后,“奖励条件”将不能进行修改,请确认是否添加？', '提示', {
                confirmButtonText: '确 认',
                cancelButtonText: '取 消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        this.$api.post('brand/brand_reward_cash_back_update', this.depositForm, res => {
                            if (res.code == 0) {
                                this.$message.success({
                                    type: 'success',
                                    message: res.msg,
                                    duration: 1500,
                                    onClose() {
                                        done();
                                        that.handleClose(1);
                                        instance.confirmButtonLoading = false;
                                    }
                                });
                            } else {
                                this.$message.error(res.msg);
                                done();
                                instance.confirmButtonLoading = false;
                            }
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {

            }).catch(() => { });
        },
        handleAdd() { //增加交易量奖励规则
            this.setting.push({
                brand_reward_conf_id: "",
                target_money: "",
                reward_money: "",
                status: 1,
                is_default: 0
            });
        },
        handleSwitch(row) {
            if (row.is_default == 1) {
                row.status = 1;
                this.$message.error('默认值不允许隐藏');
            }
        },
        handleDel(row, index) { //删除
            this.$confirm('确定删除该模板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.setting.splice(index, 1);
            }).catch(() => {

            })
        },
        handleDefault(mark) { //处理勾选时默认值
            this._.forEach(this.setting, item => {
                item.is_default = 0;
            })
            this.setting[mark].is_default = 1;
        },
        handleClose(ref) { //关闭弹窗
            this.$emit('depositClose', ref)
        },
        getInfo() { //初始化
            this.$api.post('brand/brand_reward_cash_back', { brand_id: this.brandId }, res => {
                if (res.code === 0) {
                    let data = res.data;
                    this.depositForm = data;
                    this.setting = data.setting;
                    this.comp_cb_list = data.comp_cb_list;
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
.MAM_returnDeposit * {
    font-size: 12px;

    // .el-input__inner {
    //     font-size: 12px;
    // }
    ::v-deep .el-dialog__body {
        height: 600px;
        overflow: auto;
    }

    ::v-deep .el-form-item {
        margin-bottom: 5px;

        .el-form-item__label,
        .el-radio__label {
            font-size: 12px;
        }
    }

    .el-form--label-top ::v-deep .el-form-item__label {
        padding: 0;
    }

    .el-checkbox ::v-deep .el-checkbox__label {
        font-size: 12px;
    }
}
</style>